// extracted by mini-css-extract-plugin
module.exports = {"section":"SuccessStory_section__63Pvk","heading":"SuccessStory_heading__CTEcp","heading_text":"SuccessStory_heading_text__q7EE-"};